// const active_fill = '#D20C0C';
// const active_stroke = '#D96B27';
const active_fill = '#A9FE95';
const active_stroke = '#A9FE95';
const active_extrude = '#A9FE95';
// const active_fill = '#3bb2d0';
// const active_stroke = '#3bb2d0';
// const active_extrude = '#7eb5d0';
// const inactive_fill = '#d24e52';
// const inactive_stroke = '#D96B27';
// const inactive_extrude = '#aa7447';
const inactive_fill = '#4ecbd2';
const inactive_stroke = '#9ED6DE';
const inactive_extrude = '#47aaa3';
const minimap_fill = '#003366';
const drawColor = '#FF0000';

export const previewStyles = [
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
        id: 'gl-draw-polygon-stroke-inactive',
        type: 'line',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': drawColor,
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-stroke-active',
        type: 'line',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': drawColor,
            'line-width': 4
        }
    },
    // vertex point halos
    {
        id: 'gl-draw-polygon-and-line-vertex-halo',
        type: 'line',
        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
        paint: {
            'line-color': drawColor,
            'line-width': 4
        }
    },
    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex',
        type: 'line',
        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
        paint: {
            'line-color': drawColor,
            'line-width': 4
        }
    },

    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point']
        ],
        paint: {
            'circle-radius': 4,
            'circle-color': 'cyan'
        }
    },
    // polygon fill
    {
        id: 'gl-draw-polygon-fill-inactive',
        type: 'fill',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': inactive_fill,
            'fill-outline-color': inactive_fill,
            'fill-opacity': 0
        }
    },
    {
        id: 'gl-draw-polygon-fill-active',
        type: 'fill',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': active_fill,
            'fill-outline-color': active_fill,
            'fill-opacity': 0
        }
    },
    // standalone points
    {
        id: 'gl-draw-point-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': drawColor
        }
    },
    {
        id: 'gl-draw-point-active',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['!=', 'meta', 'midpoint'],
            ['==', 'active', 'true']
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': drawColor
        }
    },
    {
        id: 'gl-draw-point-point-stroke-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 5,
            'circle-opacity': 1,
            'circle-color': drawColor
        }
    },
    {
        id: 'gl-draw-point-stroke-active',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['==', 'active', 'true'],
            ['!=', 'meta', 'midpoint']
        ],
        paint: {
            'circle-radius': 7,
            'circle-color': drawColor
        }
    },
    // line stroke
    {
        id: 'gl-draw-line-inactive',
        type: 'line',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': drawColor,
            'line-width': 2
        }
    },
    {
        id: 'gl-draw-line-active',
        type: 'line',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': drawColor,
            'line-dasharray': [0.2, 2],
            'line-width': 4
        }
    }
];

export const minimapStyles = [
    // line stroke
    {
        id: 'gl-draw-line-inactive',
        type: 'line',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': minimap_fill,
            'line-width': 2
        }
    },
    {
        id: 'gl-draw-line-active',
        type: 'line',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': minimap_fill,
            'line-dasharray': [0.2, 2],
            'line-width': 4
        }
    },

    // polygon fill
    {
        id: 'gl-draw-polygon-fill-inactive',
        type: 'fill',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': minimap_fill,
            'fill-outline-color': minimap_fill,
            'fill-opacity': 0
        }
    },
    {
        id: 'gl-draw-polygon-fill-active',
        type: 'fill',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': minimap_fill,
            'fill-outline-color': minimap_fill,
            'fill-opacity': 0
            // should be 0.1
        }
    },
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
        id: 'gl-draw-polygon-stroke-inactive',
        type: 'line',
        filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': minimap_fill,
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-stroke-active',
        type: 'line',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': minimap_fill,
            'line-dasharray': [0.2, 2],
            'line-width': 4
        }
    },
    {
        id: 'gl-draw-polygon-midpoint-halo',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
        paint: {
            'circle-radius': 5,
            'circle-color': minimap_fill
        }
    },
    {
        id: 'gl-draw-polygon-midpoint',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
        paint: {
            'circle-radius': 3.5,
            'circle-color': '#FFF',
            'circle-opacity': 0.6
        }
    },
    // vertex point halos
    {
        id: 'gl-draw-polygon-and-line-vertex-halo',
        type: 'circle',
        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
        paint: {
            'circle-radius': 7,
            'circle-color': '#FFF'
        }
    },
    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex',
        type: 'circle',
        filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
        paint: {
            'circle-radius': 6,
            'circle-color': minimap_fill
        }
    },

    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point']
        ],
        paint: {
            'circle-radius': 4,
            'circle-color': 'cyan'
        }
    },

    // polygon extrusion
    {
        id: 'gl-draw-polygon-extrusion-inactive',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height']
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': active_extrude,
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    },
    {
        id: 'gl-draw-polygon-extrusion-active',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height']
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': active_extrude,
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    },
    // standalone points
    {
        id: 'gl-draw-point-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': inactive_fill
        }
    },
    {
        id: 'gl-draw-point-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': active_fill
        }
    },
    {
        id: 'gl-draw-point-point-stroke-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 5,
            'circle-opacity': 1,
            'circle-color': inactive_stroke
        }
    },
    {
        id: 'gl-draw-point-stroke-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 7,
            'circle-color': active_stroke
        }
    },
    // standalone points
    {
        id: 'gl-draw-point-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': inactive_fill
        }
    },
    {
        id: 'gl-draw-point-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature']
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': active_fill
        }
    }
    // radius label
    // {
    //     id: 'gl-draw-radius-label',
    //     type: 'symbol',
    //     filter: ['==', 'meta', 'currentPosition'],
    //     layout: {
    //         'text-field': '{metric} \n {imperial}',
    //         'text-anchor': 'left',
    //         'text-offset': [
    //             1,
    //             0,
    //         ],
    //         'text-size': 22,
    //     },
    //     paint: {
    //         'text-color': 'rgba(0, 0, 0, 1)',
    //         'text-halo-color': 'rgba(255, 255, 255, 1)',
    //         'text-halo-width': 3,
    //         'text-halo-blur': 1,
    //     },
    // },
];

export default [
    // line stroke
    {
        id: 'gl-draw-line-inactive',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'LineString'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': inactive_stroke,
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 2
        }
    },
    {
        id: 'gl-draw-line-active',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'LineString'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': active_stroke,
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 4
        }
    },

    // polygon fill
    {
        id: 'gl-draw-polygon-fill-inactive',
        type: 'fill',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['!=', 'mode', 'static'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-color': inactive_fill,
            'fill-outline-color': inactive_fill,
            'fill-opacity': 0.1
        }
    },
    {
        id: 'gl-draw-polygon-fill-active',
        type: 'fill',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-color': active_fill,
            'fill-outline-color': active_fill,
            'fill-opacity': 0.2
        }
    },
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
        id: 'gl-draw-polygon-stroke-inactive',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['!has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': inactive_stroke,
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-stroke-active',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['!has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': active_stroke,
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-midpoint-halo',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['==', 'meta', 'midpoint'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': [
                'case',
                ['==', ['get', 'user_isLocked'], true], // If user_isLocked is true, set radius to 0
                0,
                4 // Otherwise, set the default radius
            ],
            'circle-color': active_stroke
        }
    },
    {
        id: 'gl-draw-polygon-midpoint',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['==', 'meta', 'midpoint'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': [
                'case',
                ['==', ['get', 'user_isLocked'], true], // If user_isLocked is true, set radius to 0
                0,
                3 // Otherwise, set the default radius
            ],
            'circle-color': '#FFF',
            'circle-opacity': 0.6
        }
    },
    // vertex point halos
    {
        id: 'gl-draw-polygon-and-line-vertex-halo',
        type: 'circle',
        filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': [
                'case',
                ['==', ['get', 'user_isLocked'], true], // If user_isLocked is true, set radius to 0
                0,
                7 // Otherwise, set the default radius
            ],
            'circle-color': '#FFF'
        }
    },
    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex',
        type: 'circle',
        filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': [
                'case',
                ['==', ['get', 'user_isLocked'], true], // If user_isLocked is true, set radius to 0
                0,
                6 // Otherwise, set the default radius
            ],
            'circle-color': active_stroke
        }
    },

    // vertex points
    {
        id: 'gl-draw-polygon-and-line-vertex-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 12,
            'circle-opacity': 0,
            'circle-stroke-color': active_stroke,
            'circle-stroke-width': 3
        }
    },

    // polygon extrusion
    {
        id: 'gl-draw-polygon-extrusion-inactive',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': inactive_extrude,
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    },
    {
        id: 'gl-draw-polygon-extrusion-active',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': active_extrude,
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    },

    // standalone points
    {
        id: 'gl-draw-point-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': inactive_fill
        }
    },
    {
        id: 'gl-draw-point-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': active_fill
        }
    },
    {
        id: 'gl-draw-point-point-stroke-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 5,
            'circle-opacity': 1,
            'circle-color': inactive_stroke
        }
    },
    {
        id: 'gl-draw-point-stroke-active',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 7,
            'circle-color': active_stroke
        }
    },
    // Custom user styles for colour picker
    // Polygon fill
    {
        id: 'gl-draw-polygon-fill-active-colour-picker',
        type: 'fill',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_fillColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-color': ['get', 'user_fillColour'],
            'fill-outline-color': ['get', 'user_fillColour'],
            'fill-opacity': 0.2
        }
    },
    {
        id: 'gl-draw-polygon-fill-inactive-colour-picker',
        type: 'fill',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_fillColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-color': ['get', 'user_fillColour'],
            'fill-outline-color': ['get', 'user_fillColour'],
            'fill-opacity': 0.2
        }
    },
    // Polygon stroke colour and stroke style --> Filter assigned for stroke colour
    {
        id: 'gl-draw-polygon-stroke-inactive-colour-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-stroke-active-colour-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 4
        }
    },
    // Polygon stroke colour and stroke style --> Filter assigned for stroke style
    {
        id: 'gl-draw-polygon-stroke-inactive-style-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_strokeStyle'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': ['case', ['has', 'user_height'], 4, 2]
        }
    },
    {
        id: 'gl-draw-polygon-stroke-active-style-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_strokeStyle'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 4
        }
    },
    // Line stroke colour
    {
        id: 'gl-draw-line-inactive-colour-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'LineString'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 2
        }
    },
    {
        id: 'gl-draw-line-active-colour-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'LineString'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 4
        }
    },
    {
        id: 'gl-draw-line-inactive-style-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'LineString'],
            ['has', 'user_strokeStyle'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 2
        }
    },
    {
        id: 'gl-draw-line-active-style-picker',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'LineString'],
            ['has', 'user_strokeStyle'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['get', 'user_strokeColour'],
            'line-dasharray': [
                'case',
                ['==', ['get', 'user_strokeStyle'], 'solid'], // If user_strokeStyle is solid
                ['literal', [1, 0]], // solid line
                ['literal', [6, 4]]  // dashed line
            ],
            'line-width': 4
        }
    },
    // Point colour
    {
        id: 'gl-draw-point-inactive-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': ['get', 'user_strokeColour']
        }
    },
    {
        id: 'gl-draw-point-active-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': ['get', 'user_strokeColour']
        }
    },
    {
        id: 'gl-draw-point-point-stroke-inactive-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 5,
            'circle-opacity': 1,
            'circle-color': ['get', 'user_strokeColour']
        }
    },
    {
        id: 'gl-draw-point-stroke-active-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 7,
            'circle-color': ['get', 'user_strokeColour']
        }
    },
    // Vertex point colour
    {
        id: 'gl-draw-polygon-and-line-vertex-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 6,
            'circle-color': ['get', 'user_strokeColour']
        }
    },
    {
        id: 'gl-draw-polygon-and-line-vertex-active-colour-picker',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['has', 'user_strokeColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'circle-radius': 12,
            'circle-opacity': 0,
            'circle-stroke-color': ['get', 'user_strokeColour'],
            'circle-stroke-width': 3
        }
    },
    // polygon extrusion
    {
        id: 'gl-draw-polygon-extrusion-inactive-colour-picker',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height'],
            ['has', 'user_fillColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': ['get', 'user_fillColour'],
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    },
    {
        id: 'gl-draw-polygon-extrusion-active-colour-picker',
        type: 'fill-extrusion',
        filter: [
            'all',
            ['==', 'active', 'true'],
            ['==', '$type', 'Polygon'],
            ['has', 'user_height'],
            ['has', 'user_fillColour'],
            ['any', ['==', 'user_isVisible', 'true'], ['!has', 'user_isVisible']]
        ],
        paint: {
            'fill-extrusion-base': 0,
            'fill-extrusion-color': ['get', 'user_fillColour'],
            'fill-extrusion-height': ['get', 'user_height'],
            'fill-extrusion-opacity': 0.8
        }
    }
    // radius label
    // {
    //     id: 'gl-draw-radius-label',
    //     type: 'symbol',
    //     filter: ['==', 'meta', 'currentPosition'],
    //     layout: { ''visibility'': 'visible',
    //         'text-field': '{metric} \n {imperial}',
    //         'text-anchor': 'left',
    //         'text-offset': [
    //             1,
    //             0,
    //         ],
    //         'text-size': 22,
    //     },
    //     paint: {
    //         'text-color': 'rgba(0, 0, 0, 1)',
    //         'text-halo-color': 'rgba(255, 255, 255, 1)',
    //         'text-halo-width': 3,
    //         'text-halo-blur': 1,
    //     },
    // },
];
